"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepperStepLabelText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ProgressStepperStepLabelTextMixin = require("../../mixins/components/ProgressStepperStepLabelTextMixin");
var StyledProgressStepperStepLabelText = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledProgressStepperStepLabelText",
  componentId: "c11n-8-107-0__sc-10vfukr-0"
})(["", ""], _ProgressStepperStepLabelTextMixin.ProgressStepperStepLabelTextMixin);
exports.StyledProgressStepperStepLabelText = StyledProgressStepperStepLabelText;